
import React, { useCallback } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { Filter } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import FilterForm from './FilterForm';
import { VideoFilterOptions } from '@/hooks/useVideoEvents';

interface FilterPopoverProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  localFilters: VideoFilterOptions;
  activeFiltersCount: number;
  handleStatusChange: (status: string, checked: boolean) => void;
  handleContentTypeChange: (type: string, checked: boolean) => void;
  handleNotesChange: (checked: boolean) => void;
  handleStartDateChange: (date: Date | undefined) => void;
  handleEndDateChange: (date: Date | undefined) => void;
  applyFilters: () => void;
  clearFilters: () => void;
  formatDate: (date: Date | undefined) => string;
}

const FilterPopover: React.FC<FilterPopoverProps> = ({
  isOpen,
  setIsOpen,
  localFilters,
  activeFiltersCount,
  handleStatusChange,
  handleContentTypeChange,
  handleNotesChange,
  handleStartDateChange,
  handleEndDateChange,
  applyFilters,
  clearFilters,
  formatDate,
}) => {
  const toggleFilterPopover = useCallback(() => {
    console.log("Toggling filter popover, current state:", isOpen);
    setIsOpen(!isOpen);
  }, [isOpen, setIsOpen]);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button 
          variant="outline" 
          className="flex items-center gap-2 font-sans calendar-button"
          onClick={toggleFilterPopover}
        >
          <Filter className="h-4 w-4" />
          <span>Filtres</span>
          {activeFiltersCount > 0 && (
            <Badge variant="secondary" className="ml-1 calendar-filter-tag">
              {activeFiltersCount}
            </Badge>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 md:w-96">
        <FilterForm
          localFilters={localFilters}
          handleStatusChange={handleStatusChange}
          handleContentTypeChange={handleContentTypeChange}
          handleNotesChange={handleNotesChange}
          handleStartDateChange={handleStartDateChange}
          handleEndDateChange={handleEndDateChange}
          applyFilters={applyFilters}
          clearFilters={clearFilters}
          formatDate={formatDate}
        />
      </PopoverContent>
    </Popover>
  );
};

export default FilterPopover;
